@if (isInitialized) {
    <div class="d-flex flex-column ws-flex-auto h-100 w-100">
        <div class="d-flex ws-flex-none">
            <div class="ws-flex-auto ws-truncate">
                <ws-bread-crumbs [breadcrumbs]="breadcrumbs"
                                 [currentPageTitle]="filingBatch?.description"></ws-bread-crumbs>
            </div>
            <div class="ws-flex-none">
                <filing-batch-progress [filingBatch]="filingBatch" [clickable]="false"></filing-batch-progress>
            </div>
        </div>
        <div class="ws-section ws-flex-none" [hidden]="isHidden('dummy')">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title">Filing Batch</h4>
                <div class="ws-section__header__actions">
                    <div class="ws-section__header__actions__item">
                        <div class="action-button-wrapper"
                             helpTooltip
                             [helpContentId]="beginPreparationHelpContentId"
                             position="bottom">
                            @if (canEdit && isNotStarted) {
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary"
                                        [disabled]="!hasFilings || !canEnterEditMode"
                                        (click)="navigateToReturnBatch()">
                                    Begin Preparation
                                </button>
                            }
                        </div>
                        <div class="action-button-wrapper">
                            @if (isStarted) {
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary"
                                        [disabled]="!hasFilings || !canEnterEditMode"
                                        (click)="navigateToReturnBatch()"
                                        style="margin-right:0"
                                        helpTooltip
                                        [helpContentId]="continuePreparationHelpContentId"
                                        position="bottom">
                                    Continue Preparation
                                </button>
                            }
                        </div>
                        <div class="action-button-wrapper"
                             helpTooltip
                             [helpContentId]="viewReturnsHelpContentId"
                             position="bottom">
                            @if (isReadOnly) {
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary"
                                        [disabled]="!canEnterEditMode"
                                        (click)="navigateToReturnBatch()">
                                    View Returns
                                </button>
                            }
                        </div>
                        <div class="action-button-wrapper"
                             helpTooltip
                             helpContentId="filing-batch-details.amend-returns"
                             position="bottom">
                            @if (isFinalized) {
                                <button type="button"
                                        class="ace-btn btn-sm btn-secondary"
                                        [disabled]="!hasFilings || !canEnterEditMode"
                                        (click)="amendReturns()">
                                    Amend Returns
                                </button>
                            }
                        </div>
                    </div>
                    @if (filingBatch) {
                        <div class="ws-section__header__actions__item">
                            <entity-attachments buttonClass="ace-btn btn-sm btn-primary"
                                                [(hasAttachments)]="filingBatch.hasAttachments"
                                                [modalData]="attachmentsModel"
                                                [disabled]="!canEnterEditMode"
                                                helpTooltip
                                                [helpContentId]="attachmentsHelpContentId"
                                                position="bottom">
                            </entity-attachments>
                        </div>
                    }
                    @if (filingBatch) {
                        <div class="ws-section__header__actions__item">
                            <entity-comments buttonClass="ace-btn btn-sm btn-primary"
                                             [(hasComments)]="filingBatch.hasComments"
                                             [modalData]="commentsModel"
                                             [disabled]="!canEnterEditMode"
                                             helpTooltip
                                             [helpContentId]="commentsHelpContentId"
                                             position="bottom">
                            </entity-comments>
                        </div>
                    }
                    <div class="ws-section__header__actions__item">
                        <div class="action-button-wrapper"
                             helpTooltip
                             [helpContentId]="refreshHelpContentId"
                             position="bottom">
                            <button type="button"
                                    class="ace-btn btn-sm btn-secondary has-icon"
                                    (click)="refresh()"
                                    [disabled]="!canEnterEditMode || refreshing">
                                <i class="fa fa-refresh"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column ws-flex-auto">
            <div class="d-flex flex-column"
                 [ngClass]="isHidden('filing-batch-accounts') ? 'ws-flex-auto' : 'ws-flex-none'"
                 [hidden]="isHidden('filing-batch-info')">
                @if (filingBatch) {
                    <filing-batch-info-panel
                        [filingBatch]="filingBatch"
                        [canEdit]="canEdit"
                        (filingBatchUpdated)="onFilingBatchUpdated($event)"
                        (filingBatchDeleted)="onFilingBatchDeleted()">
                    </filing-batch-info-panel>
                }
            </div>
            <div class="d-flex flex-column ws-flex-auto" [hidden]="isHidden('filing-batch-accounts')">
                @if (filingBatch) {
                    <filing-batch-accounts
                        [filingBatch]="filingBatch"
                        [canEdit]="canEdit"
                        [refresh$]="refresh$">
                    </filing-batch-accounts>
                }
            </div>
        </div>
    </div>
}
